// src/components/education/periodic-table/MaterialCard.tsx
// A component that displays a material card for the Materials Explorer
// Updated to fix image display issues
import React from 'react';
import styled from 'styled-components';

export interface MaterialCardProps {
  name: string;
  description: string;
  image: string;
  onClick: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 150px;
  height: 180px;
  padding: 10px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }
`;

const ImageContainer = styled.div`
  width: 130px;
  height: 100px;
  border-radius: 8px;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-bottom: 12px;
  border: 2px solid rgba(255, 255, 255, 0.2);
`;

const MaterialImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const MaterialName = styled.div`
  color: white;
  font-weight: bold;
  font-size: 1rem;
  text-align: center;
  margin-bottom: 6px;
`;

const MaterialDescription = styled.div`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.8rem;
  text-align: center;
`;

const MaterialCard: React.FC<MaterialCardProps> = ({ 
  name, 
  description, 
  image, 
  onClick, 
  onMouseEnter, 
  onMouseLeave 
}) => {
  return (
    <Card 
      onClick={onClick} 
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <ImageContainer>
        <MaterialImage src={image} alt={name} />
      </ImageContainer>
      <MaterialName>{name}</MaterialName>
      <MaterialDescription>{description}</MaterialDescription>
    </Card>
  );
};

export default MaterialCard; 